import {theme} from "../../../../_fri/themes/theme";
import {Box, Button} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import {initTransaction} from "../../../../_fri/utils/enum";
import {useEffect} from "react";
import {CustomVoucherTitle} from "../../../../_fri/components/CustomVoucherTitle/CustomVoucherTitle";
import {Transaction} from "../../../../store/api/interface/ecommerce";
import { VoucherDetail } from "./VoucherDetail";

export const Voucher = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = !location.state ? {data: initTransaction} : location.state as { data: Transaction };


    useEffect(() => {

    }, []);

    return (
        <Box sx={{
            border:`1px ${theme.palette.common.black} solid`,
            borderRadius:"1.8rem",
            padding:"1.8rem",
            margin:"2rem",
            color: theme.palette.common.black,
            backgroundColor:theme.palette.common.white,
            marginBottom:"1rem"
        }}>
            <CustomVoucherTitle title={'Pago realizado por'}/>
            <VoucherDetail transaction={locationState.data}/>
            <Button variant="contained"
                    sx={{
                        width: "6.5rem",
                        height: "2.8rem",
                        borderRadius: "0.5rem"
                    }}
                    color="success"
                    onClick={()=> navigate('/ecommerce')}
            >
                Aceptar
            </Button>

        </Box>
    );
};